import React, {useState} from 'react';
import EmployeeCategoryService from 'src/modules/employeeCategory/employeeCategoryService';
import EmployeeCategoryFormModal from 'src/view/employeeCategory/form/EmployeeCategoryFormModal';
import AutocompleteInMemoryFormItem from 'src/view/shared/form/items/AutocompleteInMemoryFormItem';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import selectors from 'src/modules/employeeCategory/employeeCategorySelectors';

function EmployeeCategoryAutocompleteFormItem(props) {
  const {setValue, getValues} = useFormContext();
  const [modalVisible, setModalVisible] = useState(false);
  const hasPermissionToCreate = useSelector(selectors.selectPermissionToCreate);

  const doCloseModal = () => setModalVisible(false);
  const doOpenModal = () => setModalVisible(true);
  const doCreateSuccess = (record) => {
    const {name, mode} = props;
    if (mode && mode === 'multiple') {
      setValue(name, [...(getValues()[name] || []), record]);
    } else {
      setValue(name, record);
    }
    doCloseModal();
  };
  const fetchFn = (value, limit) => EmployeeCategoryService.listAutocomplete(value, limit);
  const mapper = {
    toAutocomplete(originalValue) {
      if (!originalValue) return null;
      return {key: originalValue.id, value: originalValue.id, label: originalValue.label};
    },
    toValue(originalValue) {
      if (!originalValue) return null;
      return {id: originalValue.value, label: originalValue.label};
    },
  };

  return (
    <>
      <AutocompleteInMemoryFormItem
        {...props}
        fetchFn={fetchFn}
        mapper={mapper}
        onOpenModal={doOpenModal}
        hasPermissionToCreate={hasPermissionToCreate}
      />
      {modalVisible && <EmployeeCategoryFormModal onClose={doCloseModal} onSuccess={doCreateSuccess} />}
    </>
  );
}

export default EmployeeCategoryAutocompleteFormItem;
